export const RAINBOW = ['#2c5fa5', '#359c69', '#fcbf46', '#b94c57']
export const FIXED = '#d57b64'
export const SENSOR = '#2A5FBF'
export const VALUE = '#E04B4B'
export const FUNCTION = '#a43a78'
export const SELECTION = '#accef7'
export const CARET_COLOR = '#1976d2'
